module.exports = __webpack_public_path__ + "static/media/Page-1new loanx3.4028d6d3.svg";